// extracted by mini-css-extract-plugin
export default {"mainContainer":"KeyValueEditor_mainContainer__MUMrm","fontType":"KeyValueEditor_fontType__1rtL5","select":"KeyValueEditor_select__PWwqE"};